import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { NgbDatepickerModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslocoModule } from "@ngneat/transloco";
import { NgxMaskModule } from "ngx-mask";
import { provideUikitTranslocoScope } from "../utils";
import { DatepickerComponent } from "./datepicker/datepicker.component";
import { BodyCssClassAppendDirective } from "./directives";
import { DropdownComponent } from "./dropdown/dropdown.component";
import { FormFieldErrorComponent } from "./form-field-error/form-field-error.component";
import { FormLabelComponent } from "./form-label/form-label.component";
import { HrSeparatorComponent } from "./hr-separator/hr-separator.component";
import { InputComponent } from "./input/input.component";
import { TagsInputComponent } from "./tags-input/tags-input.component";
import { TextareaComponent } from "./textarea/textarea.component";
import { UrlInputExtendedComponent } from "./url-input/url-input-extended.component";
import { UrlInputComponent } from "./url-input/url-input.component";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot({ validation: false }),
    TranslocoModule,
    NgSelectModule,
    NgbDatepickerModule,
    NgbTooltipModule
  ],
  providers: [provideUikitTranslocoScope()],
  declarations: [
    BodyCssClassAppendDirective,
    DatepickerComponent,
    DropdownComponent,
    FormFieldErrorComponent,
    FormLabelComponent,
    InputComponent,
    HrSeparatorComponent,
    TextareaComponent,
    TagsInputComponent,
    UrlInputComponent,
    UrlInputExtendedComponent
  ],
  exports: [
    DatepickerComponent,
    DropdownComponent,
    FormFieldErrorComponent,
    FormLabelComponent,
    InputComponent,
    HrSeparatorComponent,
    TextareaComponent,
    TagsInputComponent,
    UrlInputComponent,
    UrlInputExtendedComponent
  ]
})
export class FormComponentsModule {}
